import React from 'react'
import { connect } from 'react-redux';
import { localization } from '../../../../Utils/Localization/localization';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';
import { message } from 'antd';
import {
  categoriesSelector,
  getCategories
} from '../../../../Redux/Reducers/categoriesReducer';
import { ICategory, INewProduct, IPhoto } from '../../../../Utils/types';
import {
  newProductValues,
  applyNewProduct,
  newProductSelector,
  uploadPhoto,
  photoSelector
} from '../../../../Redux/Reducers/newProductReducer';
import { ProductDescription } from './ProductDescription';
import { UploadPhoto } from './UploadPhoto';
import { useHistory } from 'react-router-dom';

interface StateProps {
  language: string,
  categories: ICategory[],
  newProduct: INewProduct,
  photo: IPhoto
}
interface DispatchProps {
  getCategories: () => void,
  uploadPhoto: (file: any, id: number) => void,
  newProductValues: (name: string, value: any) => void,
  applyNewProduct: () => void
}
interface Props extends StateProps, DispatchProps { }

function AddProductPage(props: Props) {
  const [stage, setStage] = React.useState(0);
  const history = useHistory();

  React.useEffect(() => {
    props.getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function uploadPhoto(file: any) {
    props.uploadPhoto(file.target.files[0], props.newProduct.id);
  }

  function changeStage() {
    props.applyNewProduct();
    setStage(1);
  }

  function handleSubmit() {
    history.push('/');
    message.success(localization('added', props.language));
  }

  return (
    <>
      {
        stage === 0
          ? <ProductDescription
            categories={props.categories}
            language={props.language}
            name={props.newProduct.name}
            newProductValues={props.newProductValues}
            nextStage={changeStage}
            price={props.newProduct.price}
            quantity={props.newProduct.quantity}
            category={props.newProduct.categoryId}
            tags={props.newProduct.tags}
          />
          : <UploadPhoto
            img={props.photo}
            language={props.language}
            uploadPhoto={uploadPhoto}
            handleSubmit={handleSubmit}
          />
      }
    </>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state),
    categories: categoriesSelector(state),
    newProduct: newProductSelector(state),
    photo: photoSelector(state)
  }
}
const mapDispatchToProps = {
  getCategories,
  uploadPhoto,
  newProductValues,
  applyNewProduct
}

const ConnectedAddProductPage = connect(mapStateToProps, mapDispatchToProps)(AddProductPage);
export { ConnectedAddProductPage as AddProductPage };